interface BootOptions {
  /** Starts browser tracing. Present only in a dev build that has it switched on. */
  readonly loadTracing:
    | (() => Promise<{ readonly startBrowserTracing: () => unknown }>)
    | undefined;
  readonly mount: () => void;
}

/**
 * Mounts the app. With tracing on, it mounts after tracing has started, so the
 * page's first requests are traced; a tracing failure does not stop the app.
 * Without tracing, which is every production build, it mounts at once.
 */
export function bootApp({ loadTracing, mount }: BootOptions): void {
  if (loadTracing === undefined) {
    mount();
    return;
  }
  void loadTracing()
    .then(({ startBrowserTracing }) => {
      startBrowserTracing();
    })
    .catch((error: unknown) => {
      console.warn("Browser tracing did not start", error);
    })
    .finally(mount);
}
